import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=51035ecb&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51035ecb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51035ecb')) {
      api.createRecord('51035ecb', component.options)
    } else {
      api.reload('51035ecb', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=51035ecb&scoped=true&", function () {
      api.rerender('51035ecb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xk3dB1wF8JIt/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports